var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smart-components-wrapper",class:{
		'no-padding':
			!_vm.$store.state.main.mallType &&
			_vm.$route.params.path1 !== 'about-us' &&
			_vm.$route.params.path1 !== 'card-loyal',
		cabinet: _vm.cabinet,
	}},[_c('transition',{attrs:{"name":"toggleContent","mode":"out-in"}},[(_vm.changePage)?_c('div',[(_vm.showSearch)?_c('Search'):_vm._e(),(
					!_vm.$store.state.main.mallType &&
						_vm.$route.params.path1 !== 'about-us' &&
						_vm.$route.params.path1 !== 'card-loyal'
				)?_c('landing-page'):_vm._l((_vm.loopComponents),function(component,componentKey){return [_c(component.selectedComponent,{key:component.selectedComponent + componentKey,tag:"component",attrs:{"data-hash":_vm._.get(component, 'hashTag'),"contentData":_vm.getContentData(component)}})]})],2):_c('div',{key:"0",staticClass:"empty-div-loader"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }